// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"93":"blocks6","273":"blocks2","475":"blocks0","487":"blocks4","617":"blocks"}[chunkId] || chunkId) + "." + {"93":"7d3aef67","273":"4396c3cd","475":"61bf21b9","487":"572179ff","617":"a78538a8","915":"d31917d5"}[chunkId] + ".js";
};